<div class="container-fluid admin-form-page">
  <div class="row section1 align-items-center">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">Create New Category</h5>
        <p class="home-subtitle">Enter all Category details</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage admin-page-actions mr-3">
        <div><button (click)="goBack()" type="button" class="btn btn-primary btn-dashboard">Back</button>
      </div>
      <!-- <div> <a href="#"><button class="btn btn-primary btn-deshboard">Save finance details</button></a>  </div> -->
    </div>
  </div>
</div>
<div class="section1">
  @if (isCategoryCreated) {
    <div class="alert alert-success alert-dismissible fade show" style="margin:10px 0"
      role="alert">Category Created Successfully.
    </div>
  }
  @if (isInfoParamsAdded) {
    <div class="alert alert-success alert-dismissible fade show" style="margin:10px 0"
      role="alert">Informative Parameters Updated.
    </div>
  }
  @if (isSubParamsAdded) {
    <div class="alert alert-success alert-dismissible fade show" style="margin:10px 0"
      role="alert">Subjective Parameters Updated.
    </div>
  }

  <div class="applicants-details details1 admin-form-card">
    <div class="admin-form create-category-page">
      <div class="single-flow-note">
        Everything is on one page. Save category once, then configure accessibility and parameters.
      </div>

      <!-- Category Basics -->
      <section class="form-section">
        <h5 class="section-title">Category Details</h5>
        <div class="row align-items-end">
          <div class="col-12 col-lg-5">
            <div class="user-form">
              <div class="form-group">
                <label for="category-name">Category Name*</label>
                <input type="text"
                  class="form-control"
                  id="category-name"
                  [(ngModel)]="category.categoryName"
                  name="category-name"
                  placeholder="Category Name">
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <div class="user-form">
              <div class="form-group">
                <label for="category-icon">Category Icon*</label>
                <input type="file"
                  class="form-control"
                  id="category-icon"
                  name="category-icon"
                  accept="image/*"
                  (change)="fileChangeEvent($event, imageCropperModal)">
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-3">
            @if (category.icon) {
              <div class="category-icon-preview">
                <img [src]="category.icon" alt="Category Icon">
              </div>
            }
          </div>
        </div>
        <div class="section-actions">
          <button class="btn btn-primary btn-dashboard"
            type="button"
            (click)="createCategory()"
            [disabled]="creatingCategory || (!hasCategoryId && (!category.icon || !category.categoryName))">
            {{creatingCategory ? 'Saving...' : (hasCategoryId ? 'Update Category Details' : 'Save Category')}}
          </button>
        </div>
      </section>

      <!-- Accessibility -->
      <section class="form-section">
        <div class="section-title-row">
          <h5 class="section-title mb-0">Accessibility</h5>
          <button class="btn btn-primary btn-dashboard"
            type="button"
            (click)="updateCategory()"
            [disabled]="!hasCategoryId || savingCategory">
            {{savingCategory ? 'Saving...' : 'Save Accessibility'}}
          </button>
        </div>

        <div class="row">
          <div class="col-12">
            <label class="d-inline-flex align-items-center">
              <input type="checkbox"
                [(ngModel)]="category.forceEntityToUseCategoryAllowedUserActions"
                name="forceCheck"
                id="forceCheck"
                [disabled]="!hasCategoryId">
              <span class="ml-2">Force entities of this category to use these settings</span>
            </label>
          </div>
        </div>
        <div class="accessibility-grid mt-3">
          @for (x of category.allowedUserActions | keyvalue; track x; let xi = $index) {
            <label class="access-item"
              [attr.for]="'checkboxId-' + xi">
              <input type="checkbox"
                [(ngModel)]="category.allowedUserActions[x.key]"
                name="checkboxName-{{xi}}"
                id="checkboxId-{{xi}}"
                [disabled]="!hasCategoryId">
              <span>{{x.key}}</span>
            </label>
          }
        </div>
      </section>

      <!-- Informative Parameters -->
      <section class="form-section">
        <div class="section-title-row">
          <h5 class="section-title mb-0">Informative Parameters</h5>
          <button class="btn btn-primary btn-dashboard"
            type="button"
            (click)="updateInfoParams()"
            [disabled]="!hasCategoryId || savingInfo">
            {{savingInfo ? 'Saving...' : 'Save Informative Parameters'}}
          </button>
        </div>

        @for (ip of infoParamData.informative_fields; track ip; let ipi = $index) {
          <div class="param-row">
            <div class="row align-items-end">
              <div class="col-12 col-lg-4">
                <div class="user-form">
                  <div class="form-group">
                    <label for="info-param-name-{{ipi}}">Field Name*</label>
                    <input type="text"
                      class="form-control"
                      name="info-param-name-{{ipi}}"
                      id="info-param-name-{{ipi}}"
                      placeholder="Enter Parameter Name"
                      [(ngModel)]="ip.fieldName"
                      [disabled]="!hasCategoryId">
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="info-param-type-{{ipi}}">Field Type*</label>
                    <select class="form-control"
                      name="info-param-type-{{ipi}}"
                      id="info-param-type-{{ipi}}"
                      [(ngModel)]="ip.fieldType"
                      [disabled]="!hasCategoryId">
                      <option value="text">Text</option>
                      <option value="text-area">Text Area</option>
                      <option value="date">Date</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="info-param-required-{{ipi}}">Is Field Required*</label>
                    <select class="form-control"
                      name="info-param-required-{{ipi}}"
                      id="info-param-required-{{ipi}}"
                      [(ngModel)]="ip.isRequired"
                      [disabled]="!hasCategoryId">
                      <option [ngValue]="true">Yes</option>
                      <option [ngValue]="false">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-2">
                <button class="btn btn-outline-danger btn-sm delete-param-btn"
                  type="button"
                  (click)="deleteInfoItem(ipi)"
                  [disabled]="!hasCategoryId">
                  Remove
                </button>
              </div>
            </div>
          </div>
        }

        <form class="admin-form" (ngSubmit)="addInfoItem()" ngNativeValidate>
          <div class="row align-items-end">
            <div class="col-12 col-lg-4">
              <div class="user-form">
                <div class="form-group mb-0">
                  <label for="info-param">Field Name*</label>
                  <input type="text"
                    class="form-control"
                    name="info-param"
                    id="info-param"
                    placeholder="Enter Parameter Name"
                    [(ngModel)]="addInfoItemData.fieldName"
                    required>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="user-form">
                <div class="form-group mb-0">
                  <label for="info-param-type">Field Type*</label>
                  <select class="form-control"
                    name="info-param-type"
                    id="info-param-type"
                    [(ngModel)]="addInfoItemData.fieldType"
                    required>
                    <option value="text">Text</option>
                    <option value="text-area">Text Area</option>
                    <option value="date">Date</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="user-form">
                <div class="form-group mb-0">
                  <label for="info-param-required">Is Field Required*</label>
                  <select class="form-control"
                    name="info-param-required"
                    id="info-param-required"
                    [(ngModel)]="addInfoItemData.isRequired"
                    required>
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-2">
              <button class="btn btn-primary btn-dashboard w-100"
                type="submit"
                [disabled]="!hasCategoryId">
                Add Parameter
              </button>
            </div>
          </div>
        </form>
      </section>

      <!-- Subjective Parameters -->
      <section class="form-section">
        <div class="section-title-row">
          <h5 class="section-title mb-0">Subjective Parameters</h5>
          <button class="btn btn-primary btn-dashboard"
            type="button"
            (click)="updateSubParams()"
            [disabled]="!hasCategoryId || savingSub">
            {{savingSub ? 'Saving...' : 'Save Subjective Parameters'}}
          </button>
        </div>

        @for (sp of subParamData.subjective_fields; track sp; let i = $index) {
          <div class="param-row">
            <div class="row align-items-end">
              <div class="col-12 col-lg-4">
                <div class="user-form">
                  <div class="form-group">
                    <label for="sub-param-{{i}}">Field Name*</label>
                    <input type="text"
                      class="form-control"
                      name="sub-param-{{i}}"
                      id="sub-param-{{i}}"
                      placeholder="Enter Parameter Name"
                      [(ngModel)]="sp.fieldName"
                      [disabled]="!hasCategoryId">
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-2">
                <button class="btn btn-outline-danger btn-sm delete-param-btn"
                  type="button"
                  (click)="deleteSubItem(i)"
                  [disabled]="!hasCategoryId">
                  Remove
                </button>
              </div>
            </div>
          </div>
        }

        <form class="admin-form" (ngSubmit)="addSubItem()" ngNativeValidate>
          <div class="row align-items-end">
            <div class="col-12 col-lg-4">
              <div class="user-form">
                <div class="form-group mb-0">
                  <label for="sub-param-new">Field Name*</label>
                  <input type="text"
                    class="form-control"
                    name="sub-param-new"
                    id="sub-param-new"
                    placeholder="Enter Parameter Name"
                    [(ngModel)]="addSubItemData.fieldName"
                    required>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-2">
              <button class="btn btn-primary btn-dashboard w-100"
                type="submit"
                [disabled]="!hasCategoryId">
                Add Parameter
              </button>
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</div>

<ng-template #imageCropperModal>
  <div class="modal-header">
    <h5 class="modal-title">Category icon</h5>
    <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="closeCropperModal()" [disabled]="uploadingIcon">
      <span aria-hidden="true" class="">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <image-cropper
      (imageCropped)="imageCropped($event)"
      (loadImageFailed)="loadImageFailed()"
      output="blob"
      [aspectRatio]=aspectRatio
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="true"
      format="png">
    </image-cropper>
  </div>
  <div class="modal-footer justify-content-end">
    <button type="button" class="btn btn-default mr-2" data-dismiss="modal" (click)="closeCropperModal()" [disabled]="uploadingIcon">Close</button>
    <button (click)="uploadImage()" class="btn btn-primary btn-dashboard" type="button" [disabled]="uploadingIcon">
      {{uploadingIcon ? 'Uploading...' : 'Crop'}}
    </button>
  </div>
</ng-template>
</div>
